export const ALPHA_2_ISO_3166 = {
    // taken from this https://en.wikipedia.org/wiki/ISO_3166-2
    // when clicked on a ISO Code like this => https://en.wikipedia.org/wiki/ISO_3166-2:AD
    // you can copy the li html elements and easily modify them to have the ISO Codes
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AX: 'AX',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BL: 'BL',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BQ: 'BQ',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CW: 'CW',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MF: 'MF',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SONSTIGE: 'SONSTIGE',
    SR: 'SR',
    SS: 'SS',
    ST: 'ST',
    SV: 'SV',
    SX: 'SX',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW',
} as const;

export const ALPHA_2_ISO_3166_EU = {
    AT: 'AT',
    BE: 'BE',
    BG: 'BG',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DK: 'DK',
    EE: 'EE',
    ES: 'ES',
    FI: 'FI',
    FR: 'FR',
    GR: 'GR',
    HR: 'HR',
    HU: 'HU',
    IE: 'IE',
    IT: 'IT',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    MT: 'MT',
    NL: 'NL',
    PL: 'PL',
    PT: 'PT',
    RO: 'RO',
    SE: 'SE',
    SI: 'SI',
    SK: 'SK',
} as const;

export const ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166 = {
    AD: '020',
    AE: '784',
    AF: '004',
    AG: '028',
    AI: '660',
    AL: '008',
    AM: '051',
    AO: '024',
    AQ: '010',
    AR: '032',
    AS: '016',
    AT: '040',
    AU: '036',
    AW: '533',
    AX: '248',
    AZ: '031',
    BA: '070',
    BB: '052',
    BD: '050',
    BE: '056',
    BF: '854',
    BG: '100',
    BH: '048',
    BI: '108',
    BJ: '204',
    BL: '652',
    BM: '060',
    BN: '096',
    BO: '068',
    BQ: '535',
    BR: '076',
    BS: '044',
    BT: '064',
    BV: '074',
    BW: '072',
    BY: '112',
    BZ: '084',
    CA: '124',
    CC: '166',
    CD: '180',
    CF: '140',
    CG: '178',
    CH: '756',
    CI: '384',
    CK: '184',
    CL: '152',
    CM: '120',
    CN: '156',
    CO: '170',
    CR: '188',
    CU: '192',
    CV: '132',
    CW: '531',
    CX: '162',
    CY: '196',
    CZ: '203',
    DE: '276',
    DJ: '262',
    DK: '208',
    DM: '212',
    DO: '214',
    DZ: '012',
    EC: '218',
    EE: '233',
    EG: '818',
    EH: '732',
    ER: '232',
    ES: '724',
    ET: '231',
    FI: '246',
    FJ: '242',
    FK: '238',
    FM: '583',
    FO: '234',
    FR: '250',
    GA: '266',
    GB: '826',
    GD: '308',
    GE: '268',
    GF: '254',
    GG: '831',
    GH: '288',
    GI: '292',
    GL: '304',
    GM: '270',
    GN: '324',
    GP: '312',
    GQ: '226',
    GR: '300',
    GS: '239',
    GT: '320',
    GU: '316',
    GW: '624',
    GY: '328',
    HK: '344',
    HM: '334',
    HN: '340',
    HR: '191',
    HT: '332',
    HU: '348',
    ID: '360',
    IE: '372',
    IL: '376',
    IM: '833',
    IN: '356',
    IO: '086',
    IQ: '368',
    IR: '364',
    IS: '352',
    IT: '380',
    JE: '832',
    JM: '388',
    JO: '400',
    JP: '392',
    KE: '404',
    KG: '417',
    KH: '116',
    KI: '296',
    KM: '174',
    KN: '659',
    KP: '408',
    KR: '410',
    KW: '414',
    KY: '136',
    KZ: '398',
    LA: '418',
    LB: '422',
    LC: '662',
    LI: '438',
    LK: '144',
    LR: '430',
    LS: '426',
    LT: '440',
    LU: '442',
    LV: '428',
    LY: '434',
    MA: '504',
    MC: '492',
    MD: '498',
    ME: '499',
    MF: '663',
    MG: '450',
    MH: '584',
    MK: '807',
    ML: '466',
    MM: '104',
    MN: '496',
    MO: '446',
    MP: '580',
    MQ: '474',
    MR: '478',
    MS: '500',
    MT: '470',
    MU: '480',
    MV: '462',
    MW: '454',
    MX: '484',
    MY: '458',
    MZ: '508',
    NA: '516',
    NC: '540',
    NE: '562',
    NF: '574',
    NG: '566',
    NI: '558',
    NL: '528',
    NO: '578',
    NP: '524',
    NR: '520',
    NU: '570',
    NZ: '554',
    OM: '512',
    PA: '591',
    PE: '604',
    PF: '258',
    PG: '598',
    PH: '608',
    PK: '586',
    PL: '616',
    PM: '666',
    PN: '612',
    PR: '630',
    PS: '275',
    PT: '620',
    PW: '585',
    PY: '600',
    QA: '634',
    RE: '638',
    RO: '642',
    RS: '688',
    RU: '643',
    RW: '646',
    SA: '682',
    SB: '090',
    SC: '690',
    SD: '729',
    SE: '752',
    SG: '702',
    SH: '654',
    SI: '705',
    SJ: '744',
    SK: '703',
    SL: '694',
    SM: '674',
    SN: '686',
    SO: '706',
    SR: '740',
    SS: '728',
    ST: '678',
    SV: '222',
    SX: '534',
    SY: '760',
    SZ: '748',
    TC: '796',
    TD: '148',
    TF: '260',
    TG: '768',
    TH: '764',
    TJ: '762',
    TK: '772',
    TL: '626',
    TM: '795',
    TN: '788',
    TO: '776',
    TR: '792',
    TT: '780',
    TV: '798',
    TW: '158',
    TZ: '834',
    UA: '804',
    UG: '800',
    UM: '581',
    US: '840',
    UY: '858',
    UZ: '860',
    VA: '336',
    VC: '670',
    VE: '862',
    VG: '092',
    VI: '850',
    VN: '704',
    VU: '548',
    WF: '876',
    WS: '882',
    XK: '095',
    YE: '887',
    YT: '175',
    ZA: '710',
    ZM: '894',
    ZW: '716',
} as const;

// ISO 3166-1 alpha-2 → alpha-3. Same key set as ALPHA_2_ISO_3166 (SONSTIGE excluded — no alpha-3);
// the `satisfies` clause makes a missing or extra key a compile error.
// Used e.g. to send 3-letter nationality/country codes to PROCHECK24.
export const ALPHA_2_ISO_3166_MATCH_ALPHA_3_ISO_3166 = {
    AD: 'AND',
    AE: 'ARE',
    AF: 'AFG',
    AG: 'ATG',
    AI: 'AIA',
    AL: 'ALB',
    AM: 'ARM',
    AO: 'AGO',
    AQ: 'ATA',
    AR: 'ARG',
    AS: 'ASM',
    AT: 'AUT',
    AU: 'AUS',
    AW: 'ABW',
    AX: 'ALA',
    AZ: 'AZE',
    BA: 'BIH',
    BB: 'BRB',
    BD: 'BGD',
    BE: 'BEL',
    BF: 'BFA',
    BG: 'BGR',
    BH: 'BHR',
    BI: 'BDI',
    BJ: 'BEN',
    BL: 'BLM',
    BM: 'BMU',
    BN: 'BRN',
    BO: 'BOL',
    BQ: 'BES',
    BR: 'BRA',
    BS: 'BHS',
    BT: 'BTN',
    BV: 'BVT',
    BW: 'BWA',
    BY: 'BLR',
    BZ: 'BLZ',
    CA: 'CAN',
    CC: 'CCK',
    CD: 'COD',
    CF: 'CAF',
    CG: 'COG',
    CH: 'CHE',
    CI: 'CIV',
    CK: 'COK',
    CL: 'CHL',
    CM: 'CMR',
    CN: 'CHN',
    CO: 'COL',
    CR: 'CRI',
    CU: 'CUB',
    CV: 'CPV',
    CW: 'CUW',
    CX: 'CXR',
    CY: 'CYP',
    CZ: 'CZE',
    DE: 'DEU',
    DJ: 'DJI',
    DK: 'DNK',
    DM: 'DMA',
    DO: 'DOM',
    DZ: 'DZA',
    EC: 'ECU',
    EE: 'EST',
    EG: 'EGY',
    EH: 'ESH',
    ER: 'ERI',
    ES: 'ESP',
    ET: 'ETH',
    FI: 'FIN',
    FJ: 'FJI',
    FK: 'FLK',
    FM: 'FSM',
    FO: 'FRO',
    FR: 'FRA',
    GA: 'GAB',
    GB: 'GBR',
    GD: 'GRD',
    GE: 'GEO',
    GF: 'GUF',
    GG: 'GGY',
    GH: 'GHA',
    GI: 'GIB',
    GL: 'GRL',
    GM: 'GMB',
    GN: 'GIN',
    GP: 'GLP',
    GQ: 'GNQ',
    GR: 'GRC',
    GS: 'SGS',
    GT: 'GTM',
    GU: 'GUM',
    GW: 'GNB',
    GY: 'GUY',
    HK: 'HKG',
    HM: 'HMD',
    HN: 'HND',
    HR: 'HRV',
    HT: 'HTI',
    HU: 'HUN',
    ID: 'IDN',
    IE: 'IRL',
    IL: 'ISR',
    IM: 'IMN',
    IN: 'IND',
    IO: 'IOT',
    IQ: 'IRQ',
    IR: 'IRN',
    IS: 'ISL',
    IT: 'ITA',
    JE: 'JEY',
    JM: 'JAM',
    JO: 'JOR',
    JP: 'JPN',
    KE: 'KEN',
    KG: 'KGZ',
    KH: 'KHM',
    KI: 'KIR',
    KM: 'COM',
    KN: 'KNA',
    KP: 'PRK',
    KR: 'KOR',
    KW: 'KWT',
    KY: 'CYM',
    KZ: 'KAZ',
    LA: 'LAO',
    LB: 'LBN',
    LC: 'LCA',
    LI: 'LIE',
    LK: 'LKA',
    LR: 'LBR',
    LS: 'LSO',
    LT: 'LTU',
    LU: 'LUX',
    LV: 'LVA',
    LY: 'LBY',
    MA: 'MAR',
    MC: 'MCO',
    MD: 'MDA',
    ME: 'MNE',
    MF: 'MAF',
    MG: 'MDG',
    MH: 'MHL',
    MK: 'MKD',
    ML: 'MLI',
    MM: 'MMR',
    MN: 'MNG',
    MO: 'MAC',
    MP: 'MNP',
    MQ: 'MTQ',
    MR: 'MRT',
    MS: 'MSR',
    MT: 'MLT',
    MU: 'MUS',
    MV: 'MDV',
    MW: 'MWI',
    MX: 'MEX',
    MY: 'MYS',
    MZ: 'MOZ',
    NA: 'NAM',
    NC: 'NCL',
    NE: 'NER',
    NF: 'NFK',
    NG: 'NGA',
    NI: 'NIC',
    NL: 'NLD',
    NO: 'NOR',
    NP: 'NPL',
    NR: 'NRU',
    NU: 'NIU',
    NZ: 'NZL',
    OM: 'OMN',
    PA: 'PAN',
    PE: 'PER',
    PF: 'PYF',
    PG: 'PNG',
    PH: 'PHL',
    PK: 'PAK',
    PL: 'POL',
    PM: 'SPM',
    PN: 'PCN',
    PR: 'PRI',
    PS: 'PSE',
    PT: 'PRT',
    PW: 'PLW',
    PY: 'PRY',
    QA: 'QAT',
    RE: 'REU',
    RO: 'ROU',
    RS: 'SRB',
    RU: 'RUS',
    RW: 'RWA',
    SA: 'SAU',
    SB: 'SLB',
    SC: 'SYC',
    SD: 'SDN',
    SE: 'SWE',
    SG: 'SGP',
    SH: 'SHN',
    SI: 'SVN',
    SJ: 'SJM',
    SK: 'SVK',
    SL: 'SLE',
    SM: 'SMR',
    SN: 'SEN',
    SO: 'SOM',
    SR: 'SUR',
    SS: 'SSD',
    ST: 'STP',
    SV: 'SLV',
    SX: 'SXM',
    SY: 'SYR',
    SZ: 'SWZ',
    TC: 'TCA',
    TD: 'TCD',
    TF: 'ATF',
    TG: 'TGO',
    TH: 'THA',
    TJ: 'TJK',
    TK: 'TKL',
    TL: 'TLS',
    TM: 'TKM',
    TN: 'TUN',
    TO: 'TON',
    TR: 'TUR',
    TT: 'TTO',
    TV: 'TUV',
    TW: 'TWN',
    TZ: 'TZA',
    UA: 'UKR',
    UG: 'UGA',
    UM: 'UMI',
    US: 'USA',
    UY: 'URY',
    UZ: 'UZB',
    VA: 'VAT',
    VC: 'VCT',
    VE: 'VEN',
    VG: 'VGB',
    VI: 'VIR',
    VN: 'VNM',
    VU: 'VUT',
    WF: 'WLF',
    WS: 'WSM',
    YE: 'YEM',
    YT: 'MYT',
    ZA: 'ZAF',
    ZM: 'ZMB',
    ZW: 'ZWE',
} as const satisfies Record<Exclude<keyof typeof ALPHA_2_ISO_3166, 'SONSTIGE'>, string>;
